import React from 'react'
import {
  TransactionModalState,
  TransactionsDetailsItemFromServer,
} from './types'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import { CButton } from '@coreui/react-pro'
import { isLessThan24HoursAgo } from '../../../../../libs/utils'
import { Link } from 'react-router-dom'
import { path } from 'src/libs'

export const mapScopedColumns = (
  openModal: (
    modalName: keyof Omit<TransactionModalState, 'transactionId' | 'wallet'>,
    transaction: TransactionsDetailsItemFromServer,
  ) => void,
) => ({
  clientId: (item: TransactionsDetailsItemFromServer) => {
    const clientId = item.clientId

    return (
      <td>
        {clientId ? (
          <Link
            to={path.clients.details(String(clientId))}
            target="_blank"
            style={{ fontSize: 14, fontWeight: 600 }}
          >
            {clientId}
          </Link>
        ) : (
          <span>-</span>
        )}
      </td>
    )
  },

  budgetItem: (item: TransactionsDetailsItemFromServer) => {
    const budgetItem = item.budgetItem
    const type = item.type

    return (
      <td>
        {budgetItem && type === 'Budget payment' ? (
          <span>{budgetItem}</span>
        ) : (
          <span>-</span>
        )}
      </td>
    )
  },

  action: (item: TransactionsDetailsItemFromServer) => {
    if (item.walletArchivedAt) return <td></td>
    if (item.type === 'Other payment' && isLessThan24HoursAgo(item.datetime)) {
      return (
        <td>
          <CButton
            color="secondary"
            className="me-2"
            title={'Edit'}
            onClick={() => openModal('createOtherModal', item)}
          >
            <CIcon icon={cilPencil} />
          </CButton>
        </td>
      )
    }

    if (
      ['transfer', 'Outgoing int transfer', 'Incoming int transfer'].includes(
        item.type,
      )
    ) {
      return (
        <td>
          <CButton
            color="secondary"
            className="me-2"
            title={'Edit'}
            onClick={() => openModal('createTransferModal', item)}
          >
            <CIcon icon={cilPencil} />
          </CButton>
        </td>
      )
    }

    if (item.type === 'Budget payment' && isLessThan24HoursAgo(item.datetime)) {
      return (
        <td>
          <CButton
            color="secondary"
            className="me-2"
            title={'Edit'}
            onClick={() => openModal('createBudgetPaymentModal', item)}
          >
            <CIcon icon={cilPencil} />
          </CButton>
        </td>
      )
    }

    if (
      (item.type === 'dividend' || item.type === 'lp_investment') &&
      isLessThan24HoursAgo(item.datetime)
    ) {
      return (
        <td>
          <CButton
            color="secondary"
            className="me-2"
            title={'Edit'}
            onClick={() => openModal('createDividendModal', item)}
          >
            <CIcon icon={cilPencil} />
          </CButton>
        </td>
      )
    }

    if (
      (item.type === 'investment' ||
        item.type === 'lp_dividend' ||
        item.type === 'earning') &&
      isLessThan24HoursAgo(item.datetime)
    ) {
      return (
        <td>
          <CButton
            color="secondary"
            className="me-2"
            title={'Edit'}
            onClick={() => openModal('createInvestmentModal', item)}
          >
            <CIcon icon={cilPencil} />
          </CButton>
        </td>
      )
    }

    if (item.type === 'Commissions' && isLessThan24HoursAgo(item.datetime)) {
      return (
        <td>
          <CButton
            color="secondary"
            className="me-2"
            title={'Edit'}
            onClick={() => openModal('createCommissionPaymentModal', item)}
          >
            <CIcon icon={cilPencil} />
          </CButton>
        </td>
      )
    }

    return <td></td>
  },
})
